// Utility for managing products - localStorage only
const STORAGE_KEY = 'valentino_products';

export const loadProducts = async (defaultProducts) => {
  // Load from localStorage
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        console.log('Products loaded from localStorage');
        return parsed;
      }
    }
  } catch (e) {
    console.warn('Failed to load products from localStorage:', e);
  }

  // Fallback to default products
  console.log('Products loaded from default JSON');
  return defaultProducts;
};

export const saveProducts = async (products) => {
  // Save to localStorage
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    console.log('Products saved to localStorage');
    return true;
  } catch (e) {
    console.error('Failed to save products to localStorage:', e);
    return false;
  }
};

// Synchronous version for backward compatibility
export const loadProductsSync = (defaultProducts) => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (e) {
    console.warn('Failed to load products from localStorage:', e);
  }
  return defaultProducts;
};

export const clearProducts = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (e) {
    console.error('Failed to clear products from localStorage:', e);
    return false;
  }
};

export const getProductSku = (product) => {
  if (!product) return '';

  // Extract SKU from folder name pattern: P[XX]_[SKU]/
  const tryPath = (path) => {
    if (!path) return null;
    const match = path.match(/P\d+_([^/]+)\//);
    return match ? match[1] : null;
  };

  // Extract SKU from filename for legacy paths:
  // "Thumb modelli precedenti/8W2B0T31ABMREN-0-thumb.jpg" → "8W2B0T31ABMREN"
  // "01__8W2B0T31ABM0NO_NERO/8W2B0T31ABM0NO_SF.jpg" → "8W2B0T31ABM0NO"
  const tryFilename = (path) => {
    if (!path) return null;
    const filename = path.split('/').pop();
    if (!filename) return null;
    const withoutExt = filename.replace(/\.[^.]+$/, '');
    const sku = withoutExt
      .replace(/-\d+-thumb$/i, '')
      .replace(/\.thumb$/i, '')
      .replace(/-\d+$/, '')
      .replace(/_[A-Za-z]{2,4}$/i, '');
    // SKUs are alphanumeric and at least 10 chars
    return /^[A-Z0-9]{10,}$/i.test(sku) ? sku : null;
  };

  // 1. Try folder name pattern (new bags: P05_SKU/)
  const skuFromImage = tryPath(product.image);
  if (skuFromImage) return skuFromImage;

  const skuFromSlide = product.slides && product.slides.length > 0 && tryPath(product.slides[0]);
  if (skuFromSlide) return skuFromSlide;

  // 2. Try filename extraction (legacy bags without P[XX]_ folder prefix)
  const skuFromImageFilename = tryFilename(product.image);
  if (skuFromImageFilename) return skuFromImageFilename;

  const firstSlide = product.slides && product.slides.length > 0 ? product.slides[0] : null;
  const skuFromSlideFilename = firstSlide && tryFilename(firstSlide);
  if (skuFromSlideFilename) return skuFromSlideFilename;

  // 3. Use pre-extracted sku field or id as last resort
  return product.sku || String(product.id) || '';
};

export const hasStoredProducts = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== null && stored !== undefined;
  } catch (e) {
    return false;
  }
};

